import React, { useEffect, Component, Fragment, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { DateUtil } from "../../../datas/DateUtil";
import { FxmsData } from "../../../datas/FxData";
import { width } from "@mui/system";
import { FaceRetouchingOffSharp } from "@mui/icons-material";
import {DataSelecter} from "./DataSelecter";
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from "@mui/icons-material/Settings";
import IconButton from "@mui/material/Button";
import {ChartDataMart} from "./ChartDataMart";
import HighchartsHeatmap from "highcharts/modules/heatmap";
import HighchartsTreeChart from "highcharts/modules/treemap";
import HighchartsTilemap from "highcharts/modules/tilemap";

HighchartsMore(Highcharts);
HighchartsHeatmap(Highcharts);
HighchartsTreeChart(Highcharts);
HighchartsTilemap(Highcharts);

/**
 * 라인 챠트
 * 개발자 : 김영상
 * 개발년원 : 2023.7
 * @param {*} fxUiGrp 
 * @param {*} fxUiGrpItem 
 * @returns 
 */
export const FxBaseChart = (props) => {

  const { id, fxUiGrp, fxUiGrpItem, editable } = props;
  const [intervalId, setIntervalId] = useState(null);
  const [api, setApi] = useState('');

  //chart
    const [chartType, setChartType] = useState('line')
    const [designOptions, setDesignOptions] = useState({
        colors:["#f1c40f", "#2ecc71", "#9b59b6", "#e74c3c",
            "#83b4e8", "#3498db", "#00fdcb", "#ffc263", "#d35400","#d35400"],
        title:'',subTitle:'',bgColor:"#34495e",labelColor:'white',xColor:"#46627f",yColor:"#46627f",glColor:"#46627f",xGridlineWidth:1, yGridlineWidth:1,
        xType:'linear',yType:'linear',chartType:'line',stacking:'',unit:'',legendAlign:'center',legendEnabled:true,
    })
    const [sampleData, setSampleData] = useState([{name: 'Installation & Developers', data: [43934, 48656, 65165, 81827, 112143, 142383, 171533, 165174, 155157, 161454, 154610]}, {name: 'Manufacturing', data: [24916, 37941, 29742, 29851, 32490, 30282, 38121, 36885, 33726, 34243, 31050]}, {name: 'Sales & Distribution', data: [11744, 30000, 16005, 19771, 20185, 24377, 32147, 30912, 29243, 29213, 25663]}, {name: 'Operations & Maintenance', data: [null, null, null, null, null, null, null, null, 11164, 11218, 10077]}, {name: 'Other', data: [21908, 5548, 8105, 11248, 8989, 11816, 18274, 17300, 13053, 11906, 10073]}],)

    useEffect(() => {
        if(props.item.fxUiDashbItemAttrs){
            if(props.item.fxUiDashbItemAttrs.length > 0){
                let newOptions = {}
                for(let key in designOptions){
                    if(key == "colors"){
                        newOptions[key] = props.item.fxUiDashbItemAttrs.find(x=>x.attrName==key).attrVal.split(",")
                    }else if(key == "xGridlineWidth" || key == "yGridlineWidth"){
                        newOptions[key] = parseInt(props.item.fxUiDashbItemAttrs.find(x=>x.attrName==key).attrVal)
                    }else if(key == "legendEnabled"){
                        newOptions[key] = props.item.fxUiDashbItemAttrs.find(x=>x.attrName==key).attrVal == "true" ? true : false
                    } else{
                        newOptions[key] = props.item.fxUiDashbItemAttrs.find(x=>x.attrName==key).attrVal
                    }

                }
                if(props.item.fxUiDashbItemAttrs.find(x=>x.attrName=="api").attrVal != ''){
                    setApi(props.item.fxUiDashbItemAttrs.find(x=>x.attrName=="api").attrVal)
                }
                setDesignOptions(newOptions)
            }
        }

    }, []);
    useEffect(()=>{
        if(api.indexOf('h2/component/comp-selected-chart-values?') != -1){
            FxmsData.GET(api).then(res=>{
                let chartData = []
                res.data.values.map(x=>{
                    chartData.push([Date.UTC(x.date.toString().slice(0,4),
                        x.date.toString().slice(4,6),
                        x.date.toString().slice(6,8)-1,
                        x.date.toString().slice(8,10),
                        x.date.toString().slice(10,12),
                        x.date.toString().slice(12,14)),x.value])
                })
                setSampleData([{name:'h2 sample trend',data:chartData}])
            })
        }else{
            fetch(api).then(response=>{
                return response.json()
            }).then(d=>{
                setSampleData(d)
            })
        }

    },[api])

    const saveCurrentData = () => {
        let currentData = []
        currentData.push({uiNo:props.item.uiNo,attrName:'api',attrVal:api,attrType:'string'})
        for(let key in designOptions){
            currentData.push({uiNo:props.item.uiNo,attrName:key,attrVal:designOptions[key]+'',attrType:'string'})
        }
        props.save(currentData,props.item.uiNo,props.item.opId)
    }

  return (
      <>
          {props.editable && <ChartDataMart options={{designOptions,setDesignOptions}} api={setApi} handleCloseAndSave={saveCurrentData}/> }
          <HighchartsReact
              className="HighChart"
              // callback={this.setChart}
              containerProps={{ style: { width: "100%", height: "100%" } }}
              highcharts={Highcharts}
              options={{
                  colors:designOptions.colors,
                  chart: {backgroundColor: designOptions.bgColor,type:designOptions.chartType},
                  title: {text: designOptions.title, style: { color: designOptions.labelColor },},
                  subtitle: {text: designOptions.subTitle, style: { color: designOptions.labelColor },},
                  xAxis: {type: designOptions.xType, accessibility: {rangeDescription: ""},
                      labels:{format: designOptions.xType == 'datetime' ? '{value:%Y-%m-%d}' : ''
                  ,style:{color:designOptions.labelColor}},lineColor:designOptions.xColor,gridLineWidth:designOptions.xGridlineWidth,gridLineColor:designOptions.glColor},
                  yAxis: {type:designOptions.yType, title: {text:  designOptions.unit, style: { color: designOptions.labelColor }},labels:{style:{color:designOptions.labelColor}},lineColor:designOptions.yColor,lineWidth:1,gridLineWidth:designOptions.yGridlineWidth,gridLineColor:designOptions.glColor},
                  tooltip: {crosshairs: true, shared: true, valueSuffix: " " + designOptions.unit},
                  plotOptions:{series:{stacking:designOptions.stacking == ''? null : designOptions.stacking}},
                  credits:{enabled:false},
                  legend:{align:designOptions.legendAlign,enabled:designOptions.legendEnabled,itemStyle:{color:designOptions.labelColor}},
                  colorAxis: designOptions.chartType.indexOf("map") != -1 &&  {minColor: designOptions.colors[0], maxColor: designOptions.colors[1],labels:{style:{color:'white'}}},
                  series: sampleData
              }}
          />
       </>

  );
};

export default FxBaseChart;
